import { produce } from 'immer';
import {
	INDEX_PUSH_PAGE,
	INDEX_RETURN_TO_PAGE,
	INDEX_CLEAR_HISTORY
} from './index.actions';
import { IIndexState, Breadcrumb, IndexActions } from './index.types';
export const indexInitialState: IIndexState = {
	history: []
};

export function indexReducer(
	state: IIndexState = indexInitialState,
	action: IndexActions
): IIndexState {
	switch (action.type) {
		case INDEX_PUSH_PAGE:
			return pushPage(state, action.payload as Breadcrumb);
		case INDEX_RETURN_TO_PAGE:
			return returnToPage(state, action.payload as string);
		case INDEX_CLEAR_HISTORY:
			return clearHistory(state);
		default:
			return state;
	}
}

function pushPage(currentState: IIndexState, page: Breadcrumb): IIndexState {
	const pageIndex: number = currentState.history.findIndex(
		(breadcrumb: Breadcrumb) => page.id === breadcrumb.id
	);

	if (pageIndex !== -1) {
		return returnToPage(currentState, page.id);
	}

	return produce(currentState, (draftState: IIndexState) => {
		draftState.history.push(page);
	});
}

function returnToPage(currentState: IIndexState, pageId: string): IIndexState {
	return produce(currentState, (draftState: IIndexState) => {
		const pageIndex: number = draftState.history.findIndex(
			(breadcrumb: Breadcrumb) => pageId === breadcrumb.id
		);

		if (pageIndex === -1) return;

		draftState.history.splice(
			pageIndex + 1,
			draftState.history.length - pageIndex
		);
	});
}

function clearHistory(currentState: IIndexState): IIndexState {
	return produce(currentState, (draftState: IIndexState) => {
		draftState.history = [];
	});
}
